import { useSyncExternalStore } from 'react'

const MAX = 8
const store = new Map<string, string[]>()
const listeners = new Set<() => void>()
const EMPTY: string[] = []

function emit() {
  for (const l of listeners) l()
}

export function addRecent(account: string, q: string) {
  const term = q.trim()
  if (term.length < 2) return
  const list = store.get(account) ?? []
  store.set(account, [term, ...list.filter((x) => x !== term)].slice(0, MAX))
  emit()
}

export function clearRecent(account: string) {
  store.delete(account)
  emit()
}

export function clearAllRecent() {
  store.clear()
  emit()
}

export function useRecent(account: string): string[] {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb)
      return () => listeners.delete(cb)
    },
    () => store.get(account) ?? EMPTY,
  )
}
